import type { PhonePlan } from '@bookingdei/i18n/phone';

// The market's mobile numbering (INF-1) — packages/i18n/phone.ts reads it.
export const phonePlan = { dial: '+880', nationalDigits: 10, trunk: '0', mobileLead: '1', groupAfter: 4 } as const satisfies PhonePlan;
